import lang from "@/views/modules/UserRoles/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_NAME,
    },
    'status': {
        label: lang.LBL_STATUS,
        type: 'checkbox',
        field_infos: 'status',
    },
};
export default { searchFieldsDef }